
import { defineComponent, computed, reactive, toRefs, ref, watch } from 'vue'
import { MutationTypes, useStore } from '@/store'
import { message } from 'ant-design-vue'
import router from '@/router'
// 引入接口
import { UserService } from '@/api/user'
export default defineComponent({
  setup() {
    const store = useStore()
    
    let checkTime:any = null
    let timer:any = null
    const count = ref()
    const countShow = ref(true)
    const modalVisible = computed(() => store.state.loginModalState)
    const modalType = computed(() => store.state.loginModalType)
    const closeModal = () => {
      store.commit(MutationTypes.SET_LOGIN_MODAL_STATE, false)
      clearInterval(checkTime)
      checkTime = null
    }
    const wechat = reactive({
      scene_str:'',
      url:'http://39.108.138.63:5001/static/tmp/weixinqrcode.jpg',
    })
    const state = reactive({
      Account: '', // 账户
      Account1:'',
      Password: '',
      rePassword:'',
      Code:''
    })

    const handleRegister = async () => {
      const loginParams = {
        loginName: state.Account,
        password: state.Password,
      }
      const res = await UserService.resgister(loginParams)
      if (res.data.state === 2) {
        message.success(res.data.msg)
        router.go(0)
      } 
      else {
        message.error(res.data.msg)
      }
    }
    const changeMobile = async () => {
      const loginParams = {
        newMobile: state.Account1,
        verifyCode: state.Code,
      }
      const res = await UserService.changeMobile(loginParams)
      if (res.data.state === 2) {
        message.success(res.data.msg)
        setTimeout(() => {
          // setCookie('userid','', -1)
          
          router.go(0)
        }, 1000)
      } 
      else {
        message.error(res.data.msg)
      }
    }
    const bindMobile = async () => {
      const loginParams = {
        mobile: state.Account,
        verifyCode: state.Code,
        password:state.Password
      }
      const res = await UserService.bindMobile(loginParams)
      if (res.data.state === 2) {
        message.success(res.data.msg)
        setTimeout(() => {
          // setCookie('userid','', -1)
          
          router.go(0)
        }, 1000)
      } 
      else {
        message.error(res.data.msg)
      }
    }
    const handleLogin = async () => {
      const loginParams = {
        mobile: state.Account,
        password: state.Password,
        verifyCode:state.Code
      }
      const res = await UserService.login(loginParams)
      if (res.data.state === 2) {
        message.success(res.data.msg)
        router.go(0)
      } 
      else {
        message.error(res.data.msg)
      }
    }
    const handleFindPassword = async () => {
      const loginParams = {
        mobile: state.Account,
        newPassword: state.Password,
        reNewPassword:state.rePassword,
        verifyCode:state.Code
      }
      const res = await UserService.findPassword(loginParams)
      if (res.data.state === 2) {
        message.success(res.data.msg)
        showContent('login')
      } 
      else {
        message.error(res.data.msg)
      }
    }
    const handleModifyPassword = async () => {
      const loginParams = {
        orgPassword: state.Password,
        newPassword:state.rePassword,
      }
      const res = await UserService.modifyPassword(loginParams)
      if (res.data.state === 2) {
        message.success(res.data.msg)
        // setCookie('userid','', -1)
        
        router.go(0)
      } 
      else {
        message.error(res.data.msg)
      }
    }
     
    const showContent = (type:string) => {
      clearInterval(checkTime)
      checkTime = null
      if (type === 'wx') {
        getWechatScan('signin')
      }
      store.commit(MutationTypes.SET_LOGIN_MODAL_TYPE, type)
      
    }
    const getLoginCode = async () => {
      const TIME_COUNT = 60
      if (!timer) {
        count.value = TIME_COUNT
        countShow.value = false
        timer = setInterval(() => {
          if (count.value > 0 && count.value <= TIME_COUNT) {
            count.value--
          }
          else {
            countShow.value = true
            clearInterval(timer)
            timer = null
          }
        },1000)
      }
      const loginParams = {
        mobile: state.Account,
      }
      await UserService.getLoginCode(loginParams)
    }
    const getRegCode = async () => {
      const TIME_COUNT = 60
      if (!timer) {
        count.value = TIME_COUNT
        countShow.value = false
        timer = setInterval(() => {
          if (count.value > 0 && count.value <= TIME_COUNT) {
            count.value--
          }
          else {
            countShow.value = true
            clearInterval(timer)
            timer = null
          }
        },1000)
      }
      const loginParams = {
        mobile: state.Account,
      }
      await UserService.getRegCode(loginParams)
    }
    const getPasswordCode = async () => {
      const TIME_COUNT = 60
      if (!timer) {
        count.value = TIME_COUNT
        countShow.value = false
        timer = setInterval(() => {
          if (count.value > 0 && count.value <= TIME_COUNT) {
            count.value--
          }
          else {
            countShow.value = true
            clearInterval(timer)
            timer = null
          }
        },1000)
      }
      const loginParams = {
        mobile: state.Account,
      }
      await UserService.getPasswordCode(loginParams)
    }
    const getChangeMobileCode = async () => {
      const TIME_COUNT = 60
      if (!timer) {
        count.value = TIME_COUNT
        countShow.value = false
        timer = setInterval(() => {
          if (count.value > 0 && count.value <= TIME_COUNT) {
            count.value--
          }
          else {
            countShow.value = true
            clearInterval(timer)
            timer = null
          }
        },1000)
      }
      const loginParams = {
        newMobile: state.Account1,
      }
      await UserService.getChangeMobileCode(loginParams)
    }
    const getBindMobileCode = async () => {
      const TIME_COUNT = 60
      if (!timer) {
        count.value = TIME_COUNT
        countShow.value = false
        timer = setInterval(() => {
          if (count.value > 0 && count.value <= TIME_COUNT) {
            count.value--
          }
          else {
            countShow.value = true
            clearInterval(timer)
            timer = null
          }
        },1000)
      }
      const loginParams = {
        mobile: state.Account,
      }
      await UserService.getBindMobileCode(loginParams)
    }
    
    const getWechatScan = async (type: string | undefined) => {
      const loginParams = {
        opt:type
      }
      const res = await UserService.wechatScan(loginParams)
      if (res.data.state === 2) {
        wechat.scene_str = res.data.data.scene_str
        wechat.url = res.data.data.url
        if (!checkTime) {
          checkTime = setInterval(() => {
            checkWechat()
          }, 2000)
        }

      }
      else {
        message.error(res.data.msg)
      }
    }
    const checkWechat = async () => {
      const loginParams = {
        scene_str: wechat.scene_str
      }
      const res = await UserService.wechatCheck(loginParams)
      if (res.data.state === 2) {
        clearInterval(checkTime)
        router.go(0)
        checkTime = null
      }
      else {
        if (res.data.msg !== '等待微信回调') {
          message.error(res.data.msg)
          clearInterval(checkTime)
          checkTime = null
          
        }
        
      }
    }
    watch(() => modalVisible.value,() => {
      if (modalType.value === 'wx' && modalVisible.value) {
        getWechatScan('signin')
      }
      if (modalType.value === 'bindWx' && modalVisible.value) {
        getWechatScan('bind')
      }
      if (modalType.value === 'unbindWx' && modalVisible.value) {
        getWechatScan('unbind')
      }
    })

    return {
      closeModal,
      modalVisible,
      modalType,
      ...toRefs(state),
      ...toRefs(wechat),
      handleRegister,
      handleLogin,
      handleFindPassword,
      handleModifyPassword,
      showContent,
      getLoginCode,
      getRegCode,
      getPasswordCode,
      getChangeMobileCode,
      getBindMobileCode,
      changeMobile,
      bindMobile,
      count,
      countShow
    }
  },
})
